<script setup lang="ts">
/**
 * Marcus logo: symbol + wordmark, from the brand kit (MAR-1433). Source files:
 * `public/brand/marcus-logo-rust.svg` and `public/brand/marcus-logo-pale-mineral.svg` (1200x288).
 *
 * Primary Rust on light surfaces, Primary Pale Mineral on dark ones. The kit ships each colour as its
 * own file with the colour baked in, so the theme switch is two images toggled by the `.dark` class
 * (`dark:` utilities) rather than a recolour — the colours stay exactly the kit's. Size it with a
 * height class (`h-6`); the width follows the 1200:288 aspect ratio.
 *
 * `tone="pale-mineral"` pins the light-on-dark file for surfaces that are dark in BOTH themes.
 */
withDefaults(defineProps<{ label?: string; tone?: 'auto' | 'pale-mineral' }>(), {
  label: 'Marcus',
  tone: 'auto',
})
</script>

<template>
  <span class="inline-flex shrink-0 aspect-[1200/288]" role="img" :aria-label="label">
    <img
      v-if="tone === 'auto'"
      src="/brand/marcus-logo-rust.svg"
      alt=""
      width="1200"
      height="288"
      class="block h-full w-auto dark:hidden"
    >
    <img
      src="/brand/marcus-logo-pale-mineral.svg"
      alt=""
      width="1200"
      height="288"
      :class="tone === 'auto' ? 'hidden h-full w-auto dark:block' : 'block h-full w-auto'"
    >
  </span>
</template>
